import template from './areaPlaceholder.html';
import './areaPlaceholder.scss';

export default {
  template,
  bindings: {
    icon: '@',
    text: '@',
  },
};
